export default __webpack_public_path__ + "static/media/Banner-T-Carpet tiles.32648ab9.jpg";